import React, { useReducer, useState } from 'react';
import { View, Platform } from 'react-native';
import { Container } from 'components/src';
import {
  ChatScreen,
  ContactScreen,
  ConversationScreen,
  ProfileContactScreen,
  ProfileScreen,
} from '../../templates';
import { StackScreenProps } from '@react-navigation/stack';
import { ParamList } from '../../app/RouteConfig/jsdoc';
import { createUseStyles, routesName } from 'core/src';
import { Staging } from '../../molecules';
import { initialState, reducer, updateChatInfo } from './store';

const Home = ({ navigation }: StackScreenProps<ParamList, routesName.HOME>) => {
  const { styles } = useStyles();
  const [open, setOpen] = useState<string>('');
  const [openChat, setOpenChat] = useState<string>('');

  const [{ chatInfo }, dispatch] = useReducer(reducer, initialState);

  return (
    <Container>
      <View style={styles.container}>
        <View style={[styles.sidebar, styles.shadow]}>
          {open === 'contact' ? (
            <ContactScreen setOpen={setOpen} navigation={navigation} />
          ) : open === 'profile' ? (
            <ProfileScreen
              navigation={navigation}
              setOpen={setOpen}
              dispatching={dispatch}
              setInfo={updateChatInfo}
              setOpenChat={setOpenChat}
            />
          ) : open === 'profileContact' ? (
            <ProfileContactScreen
              isChannelAdmin={true}
              conversationId={chatInfo?.chatId}
              setOpen={setOpen}
              navigation={navigation}
              avatar={chatInfo.avatar}
            />
          ) : (
            <ConversationScreen
              navigation={navigation}
              dispatching={dispatch}
              setInfo={updateChatInfo}
              chatInfo={chatInfo}
              setOpenChat={setOpenChat}
              setOpen={setOpen}
            />
          )}
        </View>

        <View style={styles.chat}>
          {openChat === 'chat' ? (
            <ChatScreen
              setOpen={setOpen}
              name={chatInfo?.name}
              conversationId={chatInfo?.chatId}
              navigation={navigation}
              status={chatInfo?.status}
              avatar={chatInfo?.avatar}
              unread={chatInfo?.unread}
            />
          ) : (
            <Staging />
          )}
        </View>
      </View>
    </Container>
  );
};

const useStyles = createUseStyles<any>(() => ({
  container: {
    flexDirection: 'row',
  },
  chat: {
    zIndex: -1,
    width: '70%',
    ...Platform.select({
      web: {
        height: '100vh',
      },
    }),
  },
  sidebar: {
    width: '30%',
    ...Platform.select({
      web: {
        height: '100vh',
      },
    }),
  },
  shadow: {
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
      },
      android: {
        elevation: 5,
      },
      web: {
        boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
      },
    }),
  },
}));

export { Home };
